/**
 * This method is called to set background colors based on the hash of the name.
 * @param name - can be any name
 * @returns color index calculated from the email hash
 */
export function generateColorFromName(name: string): string {
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = name.charCodeAt(i) + ((hash << 5) - hash);
	}

	// Generate a hex color from the hash
	let color = '#';
	for (let i = 0; i < 3; i++) {
		const value = (hash >> (i * 8)) & 0xff;
		color += ('00' + value.toString(16)).slice(-2);
	}
	return color;
}

/**
 * This function will return the initials for the organization
 * @param orgName - organization name as a string
 */
export function generateInitials(orgName: string): string {
	const name = orgName.trim();
	return name.split(' ')[0].charAt(0).toUpperCase() + (name.split(' ')[1]?.charAt(0).toUpperCase() || '');
}
